import { render, staticRenderFns } from "./AdminRegister.vue?vue&type=template&id=3da02ea8&"
import script from "../../services/admin/admin-register.js?vue&type=script&lang=js&"
export * from "../../services/admin/admin-register.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports